"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const InputCheckbox_1 = __importDefault(require("../../../global/Inputs/InputCheckbox"));
const BooleanCustomWidget = (props) => {
    const { id, value, label, disabled, onChange, required, schema } = props;
    const checked = typeof schema.default === 'boolean' && typeof value === 'undefined' ? schema.default : value || false;
    return (react_1.default.createElement(InputCheckbox_1.default, { name: id, label: label, checked: checked, isDisabled: disabled, isRequired: required, onChange: () => onChange(!checked) }));
};
exports.default = BooleanCustomWidget;
